export class deleteProductMatData {
    productId?:number;
    routerLink?:string;
}
